<template>
    <b-row v-if="options" align-v="end" align-h="start">
        <b-col cols="0.5" v-if="options.isShowMakeArchive">
          <md-button id="actionsID" class="md-raised" size="sm"  >{{ $t('Make archives') }}</md-button>
          <b-popover target="actionsID" triggers="click" placement="right">
            <template #title>{{ $t('Archive type') }}</template>

            <li style="list-style-type: none;">
              <md-button @click.stop="makeArchive('local')" class="md-raised" >{{ $t('Local archive') }}</md-button>
            </li>
            <li style="list-style-type: none;">
              <md-button @click.stop="makeArchive('remote')" class="md-raised" >{{ $t('Remote archive') }}</md-button>
            </li>

          </b-popover>
        </b-col>

        <b-col v-if="options.isShowAddButton" md="auto">
          <md-button @click.stop="ClickOnAddButton" class="md-raised">{{ $t('Add') }}</md-button>
        </b-col>
        <b-col v-if="options.isShowClearButton" md="auto">
          <md-button @click.stop="ClickOnClearButton" class="md-raised md-accent">{{ $t('Clear') }}</md-button>
        </b-col>
        <b-col v-if="options.isShowCheckButton" md="auto">
          <md-button @click.stop="ClickOnCheckButton" class="info md-raised">{{ $t('Check') }}</md-button>
        </b-col>
        <b-col v-if="options.isShowVerifyButton" md="auto">
          <md-button @click.stop="ClickOnVerifyButton" class="danger md-raised">{{ $t('Verify') }}</md-button>
        </b-col>

        <b-col md="4">
          <b-row align-v="end">
            <b-col>
            <md-field>
              <label>{{$t('Type to Search')}}</label>
              <md-input :placeholder="options.placeholder" v-model="filter" @update="filterChanged" @keypress="pressEnterFilter"></md-input>
            </md-field>
            </b-col>
            <b-col>
            <i style="margin:6px 8px 15px" @click.stop="ClickOnSearchButton" class="primary fa fa-search fa-lg"/>
            <i v-if="options.isExtendSearch" style="margin:6px 8px 15px;" @click.stop="ClickOnExtendedSearchButton" class="primary fa fa-search-plus fa-lg"/>
            <i v-if="options.isRestoredSearcher" style="margin:6px 8px 15px;" @click.stop="ClickOnRestoreSearchButton" class="primary fa fa-times-circle fa-lg"/>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="2"  v-if="!options.isDisablePerShow">
          <md-field>
            <label for="perPage">{{$t('Per page')}}</label>
            <md-select v-model="perPage" @md-selected="paginationChanged">
              <md-option v-for="item in pageOptions" :key="item" :value="item"> {{ item }} </md-option>
            </md-select>
          </md-field>
        </b-col>
        <b-col md="2" v-if="options.isCustomers">
          <md-field>
            <label for="curCustomers">{{$t('Customers')}}</label>
            <md-select v-model="curCustomers" @md-selected="customersChanged">
              <md-option v-for="item in customersOptions" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
            </md-select>
          </md-field>
        </b-col>
    </b-row>
</template>

<style>

.md-field {
  margin: 6px 8px;
}
</style>

<script>
export default {
  props: {
    options: {
      isDisablePerShow: false,
      isShowAddButton: true,
      isShowClearButton: false,
      isShowCheckButton: false,
      isShowVerifyButton: false,
      isCustomers: false,
      isExtendSearch: false,
      isRestoredSearcher: false,
      placeholder: ''
    }
  },
  data () {
    return {
      curCustomers: 0,
      filter: '',
      customersOptions: [
        {value: 0, text: this.$i18n.t('Сommon\'s')},
        {value: 1, text: this.$i18n.t('Card\'s')}
      ],
      pageOptions: [20, 40, 60, 80, 100],
      perPage: 20,
      restoreSearch: require('@/assets/img/document_delete.png'),
      addDocumentImage: require('@/assets/img/file_add.png'),
      searchDocumentImage: require('@/assets/img/search.png')
    }
  },
  methods: {
    makeArchive (type) {
      this.$emit('ClickOnMakeArchive', type)
    },
    clearFilter () {
      this.filter = ''
    },
    filterChanged () {
      this.$emit('filterChanged', this.filter)
    },
    paginationChanged () {
      this.$emit('paginationChanged', this.perPage)
    },
    customersChanged () {
      this.$emit('customersChanged', this.curCustomers)
    },
    ClickOnAddButton () {
      this.$emit('ClickOnAddButton')
    },
    ClickOnClearButton () {
      this.$emit('ClickOnClearButton')
    },
    ClickOnCheckButton () {
      this.$emit('ClickOnCheckButton')
    },
    ClickOnVerifyButton () {
      this.$emit('ClickOnVerifyButton')
    },
    ClickOnSearchButton () {
      this.$emit('filterChanged', this.filter)
      this.$emit('ClickOnSearchButton')
    },
    pressEnterFilter (event) {
      if (event.keyCode === 13) {
        this.$emit('filterChanged', this.filter)
        this.$emit('ClickOnSearchButton')
      }
    },
    ClickOnExtendedSearchButton () {
      this.$emit('ClickOnExtendedSearchButton')
    },
    ClickOnRestoreSearchButton () {
      this.$emit('ClickOnRestoreSearchButton')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/TableManager.vue